import ws from '../../ws';
import getToken from '../../redux/actions/getToken';

class SlugError extends Error {
  slug = 'Курс с таким URL уже существует';
}

const asyncValidate = async (values) => {
  const token = getToken();
  const data = { slug: values.slug, token };
  data.id = Object.prototype.hasOwnProperty.call(values, 'id') ? values.id : null;

  return new Promise((resolve, reject) => {
    ws.emit('api/academy/courses/checkAsyncData', data, (result) => {
      const { status, payload } = result;

      if (status === 'ok' && payload) {
        reject(new SlugError());
      } else {
        resolve();
      }
    });
  });
};

export default asyncValidate;
